module.exports = __webpack_public_path__ + "img/left-front-arm.d4714dce.svg";